import { useEffect, useState } from 'react';
import HeadOfficeNavBar from '../../components/ShopNavBar'
import { query, collection, where, updateDoc, doc, onSnapshot, Timestamp } from 'firebase/firestore';
import { db } from '../../firebase/firebaseConfig';
import { useLocation, useNavigate } from 'react-router-dom';
import MySelector from '../../components/MySelector';
import { ICONS } from '../../utils/icons';
import ManagerNavBar from '../../components/ManagerNavBar';


const ManagerDashboard = () => {
    const [currentUser, setCurrentUser] = useState([]);
    const [loading, setLoading] = useState(true);
    const [allUsers, setAllUsers] = useState([]);

    useEffect(() => {
        const storedUserData = localStorage.getItem('user');
        if (storedUserData) {
            const parsedUserData = JSON.parse(storedUserData);
            setCurrentUser(parsedUserData);
            setLoading(false);
            console.log("No user data received from navigation state or localStorage.");
        }

    }, []);

    const fetchUsers = () => {
        setLoading(true);

        const q = query(
            collection(db, 'users')
        );

        onSnapshot(q, (snapshot) => {
            const fetchedUsers = snapshot.docs.map(doc => {
                const data = doc.data();
                return {
                    id: doc.id,
                    ...data,
                };
            });

            setLoading(false);
            let filtered = fetchedUsers.filter(user => user.id !== currentUser.id);

            // Sort in descending order
            filtered.sort((a, b) => {
                const dateA = a.createdAt instanceof Timestamp ? a.createdAt.toDate() : new Date(a.createdAt);
                const dateB = b.createdAt instanceof Timestamp ? b.createdAt.toDate() : new Date(b.createdAt);
                return dateB - dateA;
            });

            setAllUsers(filtered);
        });
    };


    useEffect(() => {
        fetchUsers();
    }, []);



    const handleUserDeactivate = async (userId) => {
        try {
            // Update the job status in Firestore
            const userRef = doc(db, 'users', userId);
            await updateDoc(userRef, { is_active: false });

            // Update the local state to reflect the change
            setAllUsers(prevUsers => prevUsers.map(user =>
                user.id === userId ? { ...user, is_active: false } : user
            ));
        } catch (error) {
            console.error('Error updating user status:', error);
        }
    };

    const handleUserActivate = async (userId) => {
        try {
            // Update the job status in Firestore
            const userRef = doc(db, 'users', userId);
            await updateDoc(userRef, { is_active: true });

            // Update the local state to reflect the change
            setAllUsers(prevUsers => prevUsers.map(user =>
                user.id === userId ? { ...user, is_active: true } : user
            ));
        } catch (error) {
            console.error('Error updating user status:', error);
        }
    };



    return (
        <div className='bg-background min-h-screen'>
            <ManagerNavBar user={currentUser} />
            <div className='px-4 pt-6 md:px-10 lg:px-40 pb-5 min-h-screen flex flex-col'>
                <div className="py-16 md:py-24 flex-1 flex flex-col">
                    <h2 className='text-black font-bold font-20 md:text-[28px] my-5'>Welcome back! {currentUser?.storeName || "Guest"} </h2>
                    <div className='flex items-center justify-between space-x-6'>
                        <h2 className='text-black font-medium font-16 md:text-[20px]'>All Stores</h2>
                        <div
                            className='flex items-center space-x-2'
                        >

                        </div>
                    </div>
                    {loading ? (
                        // Display loading spinner/message while fetching jobs
                        <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50 z-50">
                            <div className="bg-white p-4 rounded-md shadow-lg">
                                <p className="text-lg font-semibold">Loading...</p>
                            </div>
                        </div>
                    ) :
                        allUsers.length > 1 ? (
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 md:gap-5 lg:gap-6 mt-10">
                                {
                                    allUsers.map((user, index) => (
                                        user.id !== currentUser.id &&
                                        <div key={index} className={'relative p-4 rounded-3xl bg-white dashboard-item-container'}>
                                            <div
                                                className='flex items-center justify-between'
                                            >
                                                <p className="font-18 text-primary font-bold">{user.storeName}</p>
                                                <p className="font-18 text-secondary font-bold">{user.email}</p>
                                            </div>
                                            <div className='horizontal-divider my-5' />
                                            <div
                                                className='flex items-center justify-end mt-8 gap-3 mb-4'
                                            >
                                                {
                                                    user.is_active ?
                                                        <button
                                                            type="button"
                                                            onClick={() => handleUserDeactivate(user.id)}
                                                            className="flex justify-center rounded-xl border-primary px-5 py-1.5 text-sm font-semibold leading-6 text-primary focus-visible:outline"
                                                        >
                                                            Deactivate
                                                        </button>
                                                        :
                                                        <button
                                                            type="button"
                                                            onClick={() => handleUserActivate(user.id)}
                                                            className="flex justify-center rounded-xl border-primary bg-primary px-5 py-1.5 text-sm font-semibold leading-6 text-white focus-visible:outline "
                                                        >
                                                            Activate
                                                        </button>
                                                }
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        )
                            :
                            <div className='flex-1 flex items-center justify-center'>
                                <h2 className='text-black font-bold font-35'>No Stores found</h2>
                            </div>
                    }

                </div>
            </div>
        </div>
    )
}

export default ManagerDashboard;
